module.exports = __webpack_public_path__ + "static/img/Error.76fd68d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Error.svg
// module id = s0on
// module chunks = 1